export default "__VITE_ASSET__BGIumGbP__"